import { redirect, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/store/play-for-free')({
  beforeLoad: async ({ search }) => {
    search.store = 'play-for-free'
    throw redirect({ to: '/', search })
  },
})
